import { render, staticRenderFns } from "./CardMobile.vue?vue&type=template&id=efb43a8e&scoped=true&"
import script from "./CardMobile.vue?vue&type=script&lang=js&"
export * from "./CardMobile.vue?vue&type=script&lang=js&"
import style0 from "./CardMobile.vue?vue&type=style&index=0&id=efb43a8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb43a8e",
  null
  
)

component.options.__file = "CardMobile.vue"
export default component.exports